import React, { createContext, useContext, useState } from 'react';
const ThemeLanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
 const [locale, setLocale]= useState("zhCN")
    return (
        <ThemeLanguageContext.Provider value={{ locale , setLocale}}>
            {children}
        </ThemeLanguageContext.Provider>
    );
};

export const useLanguage= () => useContext(ThemeLanguageContext);
